import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/i18n";
import CookieBanner from "@/components/CookieBanner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Legal from "@/pages/Legal";
import Contact from "@/pages/Contact";
import Services from "@/pages/Services";
import Dashboard from "@/pages/Dashboard";
import AdminPortal from "@/pages/AdminPortal";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster richColors position="top-right" theme="dark" />
            <CookieBanner />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/legal/:doc" element={<Legal />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services/:slug" element={<Services />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/ucp-admin" element={<AdminPortal />} />
              <Route path="*" element={<Landing />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
